import React, { Component }  from 'react'
import { Icon, Modal, Button } from 'semantic-ui-react'
import FileInput from '../../components/FileInput/FileInput'

class SectionStudentsReadCSV extends Component {
  render() {
    return (
      <Modal
        trigger={
          <Button icon labelPosition='right' color='green'> <Icon name='upload' />
          Import Students
          </Button>
        }
        closeIcon
        >
        <Modal.Header>Import Students</Modal.Header>
        <Modal.Content>
            <FileInput
              handleFileChange={this.props.handleFileChange}
              id={this.props.sectionId}
              className='sections-file-input'
              error={false}
            />
        </Modal.Content>
        <Modal.Actions>
          <Button color='green' onClick={() => this.props.handleDataSaveStudents(this.props.sectionId)}>
            <Icon name='checkmark' /> Save
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
};

export default SectionStudentsReadCSV;
